import { ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { FragmentNames } from '../../../codegen';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ClinicalNotesConsentsRequest } from '../clinical-notes-types';
import { foundationContext } from '@philips-internal/oswald-ui-foundation';
import { HealthProfessionalUser } from '../../../app/authentication';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../constants/endpoints';
import SmartcareMetricxTags from './smartcare/smartcare-metricx-tags';

export enum STATUS_OF_CONSENT {
  ACCEPTED = 'A',
  PENDING = 'P',
  REFUSED = 'R'
}

export type SmartCareClinicalNote = {
  encounterId: number;
  evolutionDescription: string;
  patientId: number;
}

export class OpenConsentModalService {

  static openConsentOptionsModal(): void {
    ModalService.openDialog({
      closeable: true,
      closeByDocument: true,
      closeByEscape: true,
      contextData: {  },
      focusOnOpen: true,
      fragment: FragmentNames.CLINICAL_NOTES_CONSENT,
      hideHeaderOnMobile: false,
      id: FragmentNames.CLINICAL_NOTES_CONSENT,
      noPadding: true,
      uuid: generateUUID(),
    } as ModalProps);
  }

  static generateConsent(request: ClinicalNotesConsentsRequest): Promise<void> {
    const user = foundationContext.getUser() as unknown as HealthProfessionalUser;

    const body = {
      ...request,
      professionalCode: Number(user.physicalPersonId)
    } as unknown as Record<string, Value>

    return HttpService.post(Endpoint.CLINICAL_NOTES_GENERATE_CONSENT, {}, { body })
      .then(() => {});
  }

  static saveSmartCareClinicalNote(request: SmartCareClinicalNote): Promise<{ evolutionId: number }> {
    const body = {
      evolutionDescription: request.evolutionDescription,
      consultationRecordExecutionTag: SmartcareMetricxTags.getExecutionTag()
    } as unknown as Record<string, Value>;

    return HttpService
      .post(Endpoint.CLINICAL_NOTES_SAVE_SMARTCARE_CLINICAL_NOTE, { encounterId: request.encounterId, patientId: request.patientId }, { body })
      .then((response) => response.body as { evolutionId: number });
  }
}